import { LANGUAGE_FROM_TOLGEE } from 'consts/languageFromTolgee'

import { TOLGEE_KEYS } from './translate'

export const QUESTIONS_TRANSLATIONS = {
  whatIsSoa: TOLGEE_KEYS.whatIsSoaQuestion,
  isItGood: TOLGEE_KEYS.isItGoodQuestion,
  whatInsights: TOLGEE_KEYS.whatInsightsQuestion,
  whatInsightsDaily: TOLGEE_KEYS.whatInsightsDailyQuestion,
  howToIncreasePosition: TOLGEE_KEYS.howToIncreasePositionQuestion,
  whichPlatformToImprove: TOLGEE_KEYS.whichPlatformToImproveQuestion,
  howToIncreasePositionOnRanking: TOLGEE_KEYS.howToIncreasePositionOnRankingQuestion,
  whichContentIsStandingOut: TOLGEE_KEYS.whichContentIsStandingOutQuestion,
}

export const DEFAULT_ANSWER_LANGUAGE = LANGUAGE_FROM_TOLGEE['pt-BR']
